import uuidv4 from "uuid/v4";
import moment from "moment";

let notes = [];

// Read Existing notes from the local storage
const loadNotes = () => {
  const notesJSON = localStorage.getItem("notes");
  try {
    return notesJSON ? JSON.parse(notesJSON) : [];
  } catch (e) {
    return [];
  }
};

// Save the notes to the local storage
const saveToLocalStorage = () => {
  localStorage.setItem("notes", JSON.stringify(notes));
};

// Expose notes from module
const getNotes = () => notes;

const createNote = () => {
  const uid = uuidv4();
  const createdAtTimeStamp = moment().valueOf();
  notes.push({
    id: uid,
    title: "",
    body: "",
    createdAt: createdAtTimeStamp,
    updatedAt: createdAtTimeStamp
  });
  saveToLocalStorage();
  return uid;
};

// Remove a note by its id
const removeNote = id => {
  const getIndex = notes.findIndex(note => note.id === id);
  if (getIndex > -1) {
    notes.splice(getIndex, 1);
    saveToLocalStorage();
  }
};

// Sort the notes based on of the three ways
const sortNotes = sortBy => {
  if (sortBy === "byEdited") {
    return notes.sort((a, b) => {
      if (a.updatedAt > b.updatedAt) {
        return -1;
      } else if (a.updatedAt < b.updatedAt) {
        return 1;
      } else {
        return 0;
      }
    });
  } else if (sortBy === "byCreated") {
    return notes.sort((a, b) => {
      if (a.createdAt > b.createdAt) {
        return -1;
      } else if (a.createdAt < b.createdAt) {
        return 1;
      } else {
        return 0;
      }
    });
  } else {
    return notes.sort((a, b) => {
      if (a.title.toLowerCase() > b.title.toLowerCase()) {
        return 1;
      } else if (a.title.toLowerCase() < b.title.toLowerCase()) {
        return -1;
      } else {
        return 0;
      }
    });
  }
};

const updateNote = (id, updates) => {
  const note = notes.find(note => note.id === id);
  // Base case
  if (!note) {
    return;
  }

  if (typeof updates.title === "string") {
    note.title = updates.title;
    note.updatedAt = moment().valueOf();
  }

  if (typeof updates.body === "string") {
    note.body = updates.body;
    note.updatedAt = moment().valueOf();
  }

  saveToLocalStorage();
  return note;
};

notes = loadNotes();

export { getNotes, createNote, removeNote, sortNotes, updateNote };
